import { validationMessages } from './validationMessages.schema';

export default {
  type: 'object',
  properties: {
    password: {
      title: 'Hasło',
      type: 'string',
      fieldRequired: true
    }
  },
  allOf: [validationMessages]
};
